import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikSelect from '../formik-fields/FormikSelect.jsx';

const GridFormikSelect = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikSelect { ...props } />
    </Grid>
  );
};

GridFormikSelect.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  gridProps: PropTypes.object.isRequired,
};

export default GridFormikSelect;
